class channel_option {
  constructor(
    format = "Noformat",
    url = "http://www.tdtchannels.com",
    geo = "",
    res = "",
    lang = "",
    embed = true
  ) {
    this.format = format;
    this.url = url;
    this.geo = geo;
    this.res = res;
    this.lang = lang;
    this.embed = embed;
  }
}

export default channel_option;
